const routes = [
  {
    path: "/student/referralPartCToPartB/:type",
    name: "referralPartCToPartB",
    component: () => import("@/views/student/referralPartCToPartB/Main.vue")
  },
  {
    path: "/student/startReferral",
    name: "startReferral",
    component: () =>
      import(
        "@/views/student/referralPartCToPartB/components/startReferral.vue"
      )
  },
  {
    path: "/student/detail/:pcStudentId",
    name: "detailReferral",
    component: () =>
      import(
        "@/views/student/referralPartCToPartB/components/detailReferral.vue"
      )
  },
  {
    path: "/student/registration-detail/:registrationId",
    name: "registrationDetail",
    component: () =>
      import(
        "@/views/student/referralPartCToPartB/components/online-registration/RegistrationDetail.vue"
      )
  }
];

export default routes;
